import React from 'react';
import { Icon } from 'antd';
import QueueAnim from 'rc-queue-anim';
import TweenOne from 'rc-tween-one';
import { isImg } from './utils';

class Banner extends React.PureComponent {
  render() {
    const { ...currentProps } = this.props;
    const { dataSource } = currentProps;
    delete currentProps.dataSource;
    delete currentProps.isMobile;
    return (
      <div {...currentProps} {...dataSource.wrapper}>
        <QueueAnim
          key="QueueAnim"
          type={['bottom', 'top']}
          delay={200}
          {...dataSource.textWrapper}
        >
          <div key="title" {...dataSource.title}>
            {typeof dataSource.title.children === 'string' &&
              dataSource.title.children.match(isImg) ? (
                <img src={dataSource.title.children} width="100%" alt="img" />
              ) : (
                dataSource.title.children
              )}
          </div>
          <div key="content" {...dataSource.content}>
            {dataSource.content.children}
          </div>
          <div class="parent2" {...dataSource.button}>
          <div class="qrcode"><img alt='' width='177px' margin-right='177px' src='https://pic.hereamazing.com/webpic/images/gh_e8504fcc38b2_12801.jpg'></img></div>
          <div class="left1"><img alt='' width='20px' margin-right='10px' src='https://pic.hereamazing.com/webpic/images/minigram_logo.png'></img></div>
            <div class="left2">微信小程序</div>
            <div class="right2"> <img alt='' width='20px' margin-right='10px' src='https://pic.hereamazing.com/webpic/images/QRcordIcon.png'></img>
            </div>
          </div>
        </QueueAnim>
        <TweenOne
          animation={{
            y: '-=20',
            yoyo: true,
            repeat: -1,
            duration: 1000,
          }}
          className="banner0-icon"
          key="icon"
        >
          <Icon type="down" />
        </TweenOne>
      </div>
    );
  }
}
export default Banner;
